import { fromEvent } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Component, ElementRef, OnDestroy } from '@angular/core';


@Component({
  selector: 'sc-dropdown',
  templateUrl: './dropdown.component.html',
})
export class DropdownComponent implements OnDestroy {
  public isOpen;

  constructor(private _eref: ElementRef) {}

  toggle() {
    this.listenClose();
    this.isOpen = !this.isOpen;
  }

  listenClose() {
    fromEvent(document, 'click').pipe(
      takeWhile(() => this.isOpen))
      .subscribe(event => {
        if (!this._eref.nativeElement.contains(event['target'])) {
          this.isOpen = false;
        }
      });
  }

  ngOnDestroy() {
    this.isOpen = false;
  }
}
